import {
  SET_SELECTION_PROPS,
  RESET_SELECTION_PROPS,
  SET_SELECTION_PROPS_MUT
} from "./constants.js";
import { initialState } from "./index.js";
import selection from "../../../src/utils/nonReactiveState/selection.js";

const regex = /^(selection\/)/;
const _SET_SELECTION_PROPS = SET_SELECTION_PROPS.replace(regex, "");
const _RESET_SELECTION_PROPS = RESET_SELECTION_PROPS.replace(regex, "");

export default {
  [_SET_SELECTION_PROPS]({ commit }) {
    const newState = {
      isSelectionContinuous: selection.isSelectionContinuous(),
      isSelectionPicksOnly: selection.isSelectionPicksOnly(),
      isSelectionDrivesOnly: selection.isSelectionDrivesOnly(),
      isSelectionOneTypeOnly: selection.isSelectionOneTypeOnly(),
      selectionLength: selection.selectionList.length
    };
    commit(SET_SELECTION_PROPS_MUT, newState);
  },
  [_RESET_SELECTION_PROPS]({ commit }) {
    commit(SET_SELECTION_PROPS_MUT, initialState());
  }
};
